module.exports = __webpack_public_path__ + "img/engravingRingsize-1@2x.c5c3c8a.png";